import { render, staticRenderFns } from "./MyCheck.vue?vue&type=template&id=0e885226&scoped=true"
import script from "./MyCheck.vue?vue&type=script&lang=js"
export * from "./MyCheck.vue?vue&type=script&lang=js"
import style0 from "./MyCheck.vue?vue&type=style&index=0&id=0e885226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e885226",
  null
  
)

export default component.exports